import React from "react";

const ProgressBar = ({ bgColor, completed }) => {
  const wrapperStyles = {
    height: "12px",
    width: "100%",
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderRight: "2px solid #666666",
  };

  const containerStyles = {
    minWidth: "100%",
    width: "100%",
    backgroundColor: "#D6D6D9",
    borderRadius: "0px",
  };

  const fillerStyles = {
    height: "4px",
    width: `${completed}%`,
    maxWidth: "100%",
    backgroundColor: bgColor,
  };

  return (
    <div key={completed} style={wrapperStyles}>
      <div style={containerStyles}>
        <div style={fillerStyles}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
